import { ListPage } from "@services/common/types";
import API, { ListOptions, QueryTypeOption } from "@services/root/rootApi";
import type { LocationFilters, Location } from "./types";
import { FlattenedLocation } from "@pages/Assets/LocationProvisioning/const";

type GetLocationsOptions = QueryTypeOption & ListOptions;

export const saveLocation = async (location: Location) => {
  const response = await API.put(
    `/symphony-api/provisioning/location/${location?.id ?? ""}`,
    location
  );
  return response.data;
};

export const getLocations = async (
  filters?: LocationFilters,
  options?: GetLocationsOptions
): Promise<ListPage<Omit<Location, "details">>> => {
  const {
    maxResults,
    orderBy,
    startIndex,
    totalLimit,
    queryType = "monitoring",
  } = options ?? {};

  const excludeSimpleAssets = Boolean(filters?.excludeSimpleAssets);
  delete filters?.excludeSimpleAssets;

  if (queryType == "provisioning" && filters) {
    delete filters["status.apiError"];
    delete filters["status.inCall"];
    delete filters["status.loginError"];
    delete filters["status.pauseMonitoringStatus.paused"];
    delete filters["status.reachable"];
    delete filters["status.stale"];
  }
  const response = await API.post<ListPage<Location>>(
    `/symphony-api/${queryType}/location`,
    {
      ...filters,
    },
    {
      params: {
        maxResults,
        orderBy,
        startIndex,
        totalLimit,
        excludeSimpleAssets,
      },
    }
  );
  return response.data;
};

export const getLocation = async (id: string): Promise<Location> => {
  const response = await API.get(`/symphony-api/provisioning/location/${id}`);
  return response.data;
};

export const deleteLocations = async (ids: Location["id"][]) =>
  await API.delete(`/symphony-api/provisioning/location`, { data: ids });

export const getLocationsCommonProperties = async (id: Array<Location["id"]>) =>
  (
    await API.post<Partial<FlattenedLocation>>(
      "symphony-api/provisioning/location/commonproperties",
      { id }
    )
  ).data;

export const setLocationsCommonProperties = async (
  id: Array<Location["id"]>,
  field: Partial<FlattenedLocation>
) =>
  (
    await API.put<Partial<FlattenedLocation>>(
      "symphony-api/provisioning/location/commonproperties",
      { id, field }
    )
  ).data;

export const setLocationsProperties = async (
  locations: Array<
    Partial<FlattenedLocation> & Required<Pick<FlattenedLocation, "id">>
  >
) =>
  await API.put<never>(
    "symphony-api/provisioning/location/properties",
    locations
  );
